export { default as Input } from './component';
